import * as React from 'react';
import classes from '../../styles.css';

export default function UsedByIcon() {
  return (
    <svg
      className={classes.svgicon}
      viewBox="0 0 16 16"
      version="1.1"
      width="16"
      height="16"
    >
      <path
        fillRule="evenodd"
        // tslint:disable-next-line:max-line-length
        d="M1 4.27v7.47c0 .45.3.84.75.97l6.5 1.73c.16.05.34.05.5 0l6.5-1.73c.45-.13.75-.52.75-.97V4.27c0-.45-.3-.84-.75-.97l-6.5-1.74a1.4 1.4 0 0 0-.5 0L1.75 3.3c-.45.13-.75.52-.75.97zm7 9.09l-6-1.59V5l6 1.61v6.75zM2 4l2.5-.67L11 5.06l-2.5.67L2 4zm13 7.77l-6 1.59V6.61l2-.55V8.5l2-.53V5.53L15 5v6.77zm-2-7.24L6.5 2.8l2-.53L15 4l-2 .53z"
      />
    </svg>
  );
}
